import React from 'react';
import { ChevronDown } from 'lucide-react';

export const FAQSection = ({ faqItems, openFaq, setOpenFaq }) => {
  const handleToggle = (itemId) => {
    setOpenFaq(openFaq === itemId ? null : itemId);
  };

  return (
    <section id="faq" className="section-spacing bg-[#121212]">
      <div className="revolt-container">
        <div className="text-center mb-lg">
          <h2 className="section-title">FAQ</h2>
        </div>
        
        <div className="faq-list">
          {faqItems.map((item) => (
            <div key={item.id} className="faq-item">
              <button 
                className="faq-question"
                onClick={() => handleToggle(item.id)}
              >
                {item.question}
                <ChevronDown 
                  className={`w-5 h-5 transition-transform ${openFaq === item.id ? 'rotate-180' : ''}`}
                />
              </button>
              {openFaq === item.id && (
                <div className="faq-answer fade-in-up">
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
